import { Cell, Pie, PieChart } from 'recharts';
import React from 'react';

interface DonutChartProps {
  children?: React.ReactNode;
  donutThicknessRatio?: number;
  failureCount: number;
  height?: number;
  successCount: number;
  width?: number;
}

export const DonutChart: React.FC<DonutChartProps> = ({
  children = undefined,
  donutThicknessRatio = 0.8,
  failureCount,
  height = 140,
  successCount,
  width = 140
}) => {
  const data = [
    { name: 'Success', value: successCount, color: '#157C62' },
    { name: 'Failure', value: failureCount, color: '#7F2E2E' }
  ];

  const radius = Math.min(width, height) / 2;
  const innerRadius = radius * (1 - (1 - donutThicknessRatio) * 0.6);
  const outerRadius = radius;

  return (
    <PieChart width={140} height={140}>
      <Pie
        data={data}
        cx="50%"
        cy="50%"
        outerRadius={outerRadius}
        innerRadius={innerRadius}
        dataKey="value"
        stroke="none"
      >
        {data.map((entry) => (
          <Cell key={`cell-${entry.name}`} fill={entry.color} stroke="none" />
        ))}
      </Pie>
      {children && (
        <foreignObject x={0} y={0} width="100%" height="100%">
          <div className="flex h-full flex-col items-center justify-center text-center">
            {children}
          </div>
        </foreignObject>
      )}
    </PieChart>
  );
};

export default DonutChart;
